import { useEffect, useState } from "react";
import TopNav from "../components/TopNav.jsx";
import { SAGE } from "../lib/api";

export default function LossesPage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetch(`${SAGE}/losses`).then((r) => r.json()).then(setData).catch((e) => setErr(e.message));
  }, []);

  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-8">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-2">
          The Loss Log · every wrong answer Sage ever gave
        </div>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter uppercase text-sage-text mb-4">
          Failures, in full.
        </h1>
        <p className="text-sm text-sage-muted leading-relaxed max-w-2xl mb-8">
          Every question Sage got wrong on any monthly Cold Read benchmark run. The exact prompt, Sage's actual answer, and the Warden's reason for flagging it. No summary. No spin. No selection bias.
        </p>

        {err && <div className="border border-sage-err text-sage-err p-4 text-sm mb-6">error: {err}</div>}
        {!data && !err && <div className="text-sage-faint text-sm">loading…</div>}

        {data && data.count === 0 && (
          <div className="border border-sage-border p-6 text-sage-muted text-sm" data-testid="losses-empty">
            No losses on record yet. Either Sage hasn't run a Cold Read, or it hasn't been caught getting anything wrong. Both are provable — check the Cold Read block on the <a href="/sage-ledger" className="text-sage-accent hover:underline">Ledger</a>.
          </div>
        )}

        {data && data.count > 0 && (
          <div className="space-y-6" data-testid="losses-list">
            {data.losses.map((L, i) => (
              <div key={i} className="border border-sage-border p-6 bg-sage-elevated" data-testid={`loss-${i}`}>
                <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint flex justify-between mb-3">
                  <span>Cold Read · {new Date(L.at).toLocaleDateString()} · {L.model}</span>
                  <span className="text-sage-err">WRONG</span>
                </div>
                <div className="mb-3">
                  <div className="text-[10px] uppercase text-sage-faint mb-1">Prompt</div>
                  <div className="text-sm text-sage-text">{L.prompt}</div>
                </div>
                <div className="mb-3">
                  <div className="text-[10px] uppercase text-sage-faint mb-1">Sage's answer</div>
                  <div className="text-sm text-sage-muted whitespace-pre-wrap border-l-2 border-sage-err pl-3">{L.answer}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase text-sage-faint mb-1">Warden's reason</div>
                  <div className="text-sm text-sage-warn italic">{L.warden_note || "— no note recorded —"}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
